import styled from 'styled-components/macro';
import { bounce } from 'components/common/animations';
import * as colors from 'components/common/colorConstants';

export const Section = styled.div`
  padding: 12px 5px 10px 5px;
  width: 100%;
  position: relative;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 60px;
`;

export const Tab = styled.div`
  background-color: ${(props) => (props.selected ? colors.lightGray22 : colors.darkGray8)};
  border-radius: 5px;
  min-height: 24px;
  width: 100%;
  text-align: center;
  padding: 12px 7px 2px 7px;
  position: relative;
  transition: 0.5s;
  cursor: pointer;
  ${({ animateBounce }) => animateBounce && bounce}

  img {
    width: 24px;
    position: absolute;
    top: -12px;
    margin: 0px;
    left: ${({ isAlertDotVisible }) => (isAlertDotVisible ? '5px' : '13px')};
  }

  p {
    font-size: 10px;
    font-weight: 300;
    color: ${(props) => (props.selected ? colors.black4 : '#a6b0c6')};
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0px;
    padding: 0px;
  }
`;

export const UnreadCountWrapper = styled.div`
  position: absolute;
  top: -6px;
  right: 6px;
  margin: 0px;
`;

export const PopoverWrapper = styled.div`
  display: inline-block;
  position: absolute;
  left: ${({ left }) => `${left + 16}px`};
  top: ${({ top }) => `${top - 14}px`};
  height: 0px;
`;
